// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import PackagingAdviceFormState, {
    PackagingAdviceFormFieldValues,
} from "@store/Framework/Store/Greif/Components/PackagingAdviceForm/PackagingAdviceFormState";
import { Draft } from "immer";

const initialFormFieldValues: PackagingAdviceFormState["formFieldValues"] = {
    attachments: { value: [] },
    emailAddress: { value: "" },
    firstName: { value: "" },
    lastName: { value: "" },
    requestDetails: { value: "" },
    phoneNumber: { value: "" },
    productType: { value: "" },
    referenceProductId: { value: "" },
    shipToNumber: { value: "" },
};

const initialState: PackagingAdviceFormState = {
    formFieldValues: initialFormFieldValues,
    formDraftFieldValues: initialFormFieldValues,
    isDirty: false,
};

const actions = {
    "Greif/Components/PackagingAdviceForm/SetDraftFieldValues": (
        draft: Draft<PackagingAdviceFormState>,
        action: { parameter: PackagingAdviceFormFieldValues },
    ) => {
        draft.formDraftFieldValues = { ...draft.formDraftFieldValues, ...action.parameter };
    },
    "Greif/Components/PackagingAdviceForm/SaveDraftFieldValues": (
        draft: Draft<PackagingAdviceFormState>,
        action: { keys?: Array<keyof PackagingAdviceFormFieldValues> },
    ) => {
        const draftFieldValues = action.keys?.length
            ? action.keys.reduce((result, key) => ({ ...result, [key]: draft.formDraftFieldValues[key] }), {})
            : draft.formDraftFieldValues;

        draft.formFieldValues = { ...draft.formFieldValues, ...draftFieldValues };
        draft.isDirty = true;
    },
    "Greif/Components/PackagingAdviceForm/CancelDraftFieldValues": (
        draft: Draft<PackagingAdviceFormState>,
        action: { keys?: Array<keyof PackagingAdviceFormFieldValues> },
    ) => {
        const savedFieldValues = action.keys?.length
            ? action.keys.reduce((result, key) => ({ ...result, [key]: draft.formFieldValues[key] }), {})
            : draft.formFieldValues;

        draft.formDraftFieldValues = { ...draft.formDraftFieldValues, ...savedFieldValues };
    },
    "Greif/Components/PackagingAdviceForm/ResetFieldValues": (draft: Draft<PackagingAdviceFormState>) => {
        draft.formFieldValues = initialFormFieldValues;
        draft.formDraftFieldValues = initialFormFieldValues;
        draft.isDirty = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsPackagingAdviceFormActions = Parameters<typeof reducer>[1];
export default reducer;
